// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"53b05d10","142":"674e2ea0","299":"93211a76","355":"d5915b06","405":"ad442821","485":"3dc95d27","621":"c80c60fa","829":"510ec3bf","970":"5f484c84"}[chunkId] + ".chunk.js";
};